import React from 'react';
import classNames from 'classnames';

import './score.scss';

interface ScoreProps {
  scoreInPercentage: number;
  total: number;
  successful: number;
  successRate: number | null;
}

export const Score: React.FunctionComponent<ScoreProps> = ({ scoreInPercentage, total, successful, successRate }) => {
  const percentageRounded = Math.round(scoreInPercentage);

  return (
    <div
      className={classNames(
        'score',
        {
          'score--success': typeof successRate === 'number' ? percentageRounded >= successRate : percentageRounded >= 1,
        },
        { 'score--failure': typeof successRate === 'number' ? percentageRounded < successRate : percentageRounded < 1 }
      )}
    >
      <span className="score__completion">
        {successful}/{total}
      </span>
      <span>{scoreInPercentage.toFixed(0)}%</span>
    </div>
  );
};
